(() => {
  const desktopHover = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  let preview = null;
  let activeGallery = null;

  const ensurePreview = () => {
    if (preview) return preview;
    preview = document.createElement('div');
    preview.className = 'aurymed-image-hover-preview';
    preview.setAttribute('aria-hidden', 'true');
    preview.innerHTML = '<img alt="">';
    document.body.appendChild(preview);
    return preview;
  };

  const largestSrc = (img) => {
    if (!img) return '';
    const srcset = (img.getAttribute('srcset') || '').trim();
    if (!srcset) return img.currentSrc || img.src || '';

    const candidates = srcset
      .split(',')
      .map((entry) => entry.trim().split(/\s+/))
      .map(([url, descriptor]) => ({ url, width: parseInt(descriptor, 10) || 0 }))
      .filter((item) => item.url)
      .sort((a, b) => b.width - a.width);

    return candidates[0]?.url || img.currentSrc || img.src || '';
  };

  const positionPreview = (event) => {
    if (!preview || !preview.classList.contains('is-visible')) return;

    const gap = 18;
    const rect = preview.getBoundingClientRect();
    let x = event.clientX + gap;
    let y = event.clientY + gap;

    if (x + rect.width > window.innerWidth - 12) x = event.clientX - rect.width - gap;
    if (y + rect.height > window.innerHeight - 12) y = window.innerHeight - rect.height - 12;
    if (y < 12) y = 12;
    if (x < 12) x = 12;

    preview.style.left = `${x}px`;
    preview.style.top = `${y}px`;
  };

  const showPreview = (gallery, event) => {
    if (!desktopHover.matches) return;
    const grid = gallery.closest('.product-grid');
    const view = grid?.getAttribute('product-grid-view');
    if (view !== 'list' && view !== 'table') return;

    const img = gallery.querySelector('.product-media__image, img');
    if (!(img instanceof HTMLImageElement)) return;

    const src = largestSrc(img);
    if (!src) return;

    const node = ensurePreview();
    const previewImg = node.querySelector('img');
    previewImg.src = src;
    previewImg.alt = img.alt || '';
    node.classList.add('is-visible');
    activeGallery = gallery;
    positionPreview(event);
  };

  const hidePreview = () => {
    if (!preview) return;
    preview.classList.remove('is-visible');
    activeGallery = null;
  };

  document.addEventListener('pointerover', (event) => {
    const gallery = event.target.closest?.('collection-component .product-grid__item .card-gallery');
    if (!gallery) return;
    if (gallery === activeGallery) return;
    showPreview(gallery, event);
  });

  document.addEventListener('pointermove', (event) => {
    if (activeGallery) positionPreview(event);
  });

  document.addEventListener('pointerout', (event) => {
    if (!activeGallery) return;
    const fromGallery = event.target.closest?.('.card-gallery');
    const toGallery = event.relatedTarget?.closest?.('.card-gallery');
    if (fromGallery === activeGallery && toGallery !== activeGallery) hidePreview();
  });

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.name === 'grid' && input.value !== 'list' && input.value !== 'table') hidePreview();
  });

  window.addEventListener('scroll', hidePreview, { passive: true });
  window.addEventListener('resize', hidePreview, { passive: true });
})();

// AURYMED v69 fallback: set the requested view directly as well as through the theme event system.
(() => {
  const applyView = (input) => {
    if (!(input instanceof HTMLInputElement) || input.name !== 'grid') return;
    const view = input.value;
    if (!['default', 'large', 'zoom-out', 'list', 'table'].includes(view)) return;
    const results = input.closest('results-list') || document.querySelector('results-list');
    const grid = results?.querySelector('.product-grid') || document.querySelector('.product-grid');
    if (!grid) return;
    grid.setAttribute('product-grid-view', view);
    try { sessionStorage.setItem('product-grid-view-desktop', view); } catch (_) {}
  };

  document.addEventListener('change', (event) => applyView(event.target));

  const syncChecked = () => {
    const grid = document.querySelector('collection-component .product-grid');
    if (!grid || window.innerWidth < 750) return;
    const view = grid.getAttribute('product-grid-view') || 'default';
    document.querySelectorAll('input[name="grid"]').forEach((input) => {
      if (input instanceof HTMLInputElement) input.checked = input.value === view;
    });
  };

  document.addEventListener('DOMContentLoaded', syncChecked, { once: true });
  document.addEventListener('shopify:section:load', syncChecked);
})();

/* AURYMED v70 — collection shop tools */
(() => {
  const root = document.querySelector('collection-component');
  if (!root) return;
  const tools = root.querySelector('[data-aury-shop-tools]');
  const grid = root.querySelector('.product-grid');
  if (!tools || !grid) return;

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const norm = (value = '') => String(value).toLocaleLowerCase('de-DE').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
  const currency = window.Shopify?.currency?.active || 'EUR';
  const locale = document.documentElement.lang || 'de-DE';
  const money = (cents) => new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
  const esc = (value = '') => String(value).replace(/[&<>'"]/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const totalProducts = Number(tools.dataset.totalProducts || 0);
  const productCache = new Map();
  const activeFilters = new Set();
  let loading = false;

  const keys = {
    wishlist: 'aurymed:v70:wishlist',
    compare: 'aurymed:v70:compare',
    bulk: 'aurymed:v70:bulk',
    columns: 'aurymed:v70:columns',
    browse: 'aurymed:v70:browse'
  };

  const readStore = (key, fallback = []) => {
    try { const v = JSON.parse(localStorage.getItem(key)); return v ?? fallback; } catch (_) { return fallback; }
  };
  const writeStore = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };

  const cards = () => $$('product-card[data-aury-handle]', grid);
  const items = () => $$('.product-grid__item', grid);
  const cardMeta = (card) => ({
    handle: card.dataset.auryHandle || '',
    title: card.dataset.auryTitle || '',
    url: card.dataset.auryUrl || '',
    image: card.dataset.auryImage || '',
    price: Number(card.dataset.auryPriceMin || 0),
    search: card.dataset.aurySearch || '',
    tags: card.dataset.auryTags || '',
    unitPrice: Number(card.dataset.auryUnitPrice || 0),
    unitQty: Number(card.dataset.auryUnitQty || 0),
    hasTier: card.dataset.auryHasTier === 'true',
    available: card.dataset.auryAvailable === 'true',
    variantCount: Number(card.dataset.auryVariantCount || 0),
    defaultVariant: Number(card.dataset.auryDefaultVariant || 0),
    secondImage: card.dataset.aurySecondImage || ''
  });
  const findCard = (handle) => cards().find((c) => c.dataset.auryHandle === handle);

  // Keep the four quick-action icons in the same logical place on every collection.
  // Tile views: directly below the product image. List/table: in the action column.
  const placeActions = () => {
    const view = grid.getAttribute('product-grid-view') || 'default';
    const tileView = ['default','large','zoom-out','mobile-single'].includes(view);
    cards().forEach((card) => {
      const actions = $('.aury-card-actions', card);
      const gallery = $('.card-gallery', card);
      const content = $('.product-card__content', card);
      if (!actions || !content) return;
      if (tileView && gallery) {
        if (gallery.nextElementSibling !== actions) gallery.insertAdjacentElement('afterend', actions);
      } else if (!tileView && content.lastElementChild !== actions) {
        content.appendChild(actions);
      }
    });
  };

  const extractSize = (title) => {
    const all = [...String(title || '').matchAll(/(\d{2,3})\s*(?:[x×]\s*(\d{2,3})\s*)?mm/gi)];
    if (!all.length) return null;
    const first = all[0];
    const a = Number(first[1]);
    const b = first[2] ? Number(first[2]) : null;
    return { a, b, label: b ? `${a} × ${b} mm` : `${a} mm`, max: Math.max(a, b || a) };
  };

  const decorateCards = () => {
    cards().forEach((card) => {
      /* Keep quick actions directly below the product image in tile views.
         Moving the node here is more reliable than flex ordering because the
         native product-card children can vary between collections. */
      const gallery = $('.card-gallery', card);
      const actions = $('.aury-card-actions', card);
      if (gallery && actions && gallery.nextElementSibling !== actions) {
        gallery.insertAdjacentElement('afterend', actions);
      }

      const meta = cardMeta(card);
      const size = extractSize(meta.title);
      const target = $('[data-aury-size]', card);
      if (target && size && !target.dataset.ready) {
        const dot = Math.max(9, Math.min(22, 8 + (size.max / 110) * 14));
        target.innerHTML = `<span class="aury-card-size-dot" style="--aury-size-dot:${dot.toFixed(1)}px"></span><span>${esc(size.label)}</span>`;
        target.dataset.ready = '1';
        target.removeAttribute('aria-hidden');
      }
    });
  };

  const filterDefs = [
    { key:'tier', label:'Staffelpreis', test:(m) => m.hasTier },
    { key:'mini', label:'Mini', test:(m) => norm(m.search).includes('mini') },
    { key:'tierwelt', label:'Tier', test:(m) => /(tier|animal|krafttier)/.test(norm(m.search)) },
    { key:'anhaenger', label:'Anhänger', test:(m) => /(anhanger|amulett)/.test(norm(m.search)) },
    { key:'scheiben', label:'Scheiben', test:(m) => /(disc|scheibe|coin)/.test(norm(m.search)) },
    { key:'armband', label:'Armband', test:(m) => norm(m.search).includes('armband') },
    { key:'30-39', label:'30–39 mm', test:(m) => { const s=extractSize(m.title); return s && s.max>=30 && s.max<=39; } },
    { key:'48-50', label:'48–50 mm', test:(m) => { const s=extractSize(m.title); return s && s.max>=48 && s.max<=50; } },
    { key:'57-75', label:'57–75 mm', test:(m) => { const s=extractSize(m.title); return s && s.max>=57 && s.max<=75; } },
    { key:'90-100', label:'90–100 mm', test:(m) => { const s=extractSize(m.title); return s && s.max>=90 && s.max<=100; } },
    { key:'100plus', label:'über 100 mm', test:(m) => { const s=extractSize(m.title); return s && s.max>100; } }
  ];

  const buildChips = () => {
    const holder = $('[data-aury-filter-chips]', tools);
    if (!holder) return;
    const metas = cards().map(cardMeta);
    const parts = [];
    if (activeFilters.size) parts.push(`<button type="button" class="aurymed-chip" data-aury-chip="__clear">Alle <small>×</small></button>`);
    for (const def of filterDefs) {
      const count = metas.filter(def.test).length;
      if (!count) continue;
      parts.push(`<button type="button" class="aurymed-chip${activeFilters.has(def.key) ? ' is-active' : ''}" data-aury-chip="${def.key}">${esc(def.label)} <small>${count}</small></button>`);
    }
    holder.innerHTML = parts.join('');
  };

  const applyFilter = () => {
    const input = $('[data-aury-collection-search]', tools);
    const query = norm(input?.value || '').trim();
    const words = query.split(/\s+/).filter(Boolean);
    let visible = 0;
    items().forEach((item) => {
      const card = $('product-card[data-aury-handle]', item);
      if (!card) return;
      const meta = cardMeta(card);
      const hay = norm(`${meta.search} ${meta.tags}`);
      const textOK = words.every((word) => hay.includes(word));
      const filterOK = [...activeFilters].every((key) => filterDefs.find((d) => d.key === key)?.test(meta) ?? true);
      item.hidden = !(textOK && filterOK);
      if (!item.hidden) visible += 1;
    });
    let empty = $('.aurymed-no-results', grid.parentElement);
    if (!visible && items().length) {
      if (!empty) {
        empty = document.createElement('div'); empty.className = 'aurymed-no-results';
        empty.textContent = 'Keine Treffer in den aktuell geladenen Artikeln. Probiere einen anderen Begriff oder lade weitere Artikel.';
        grid.insertAdjacentElement('afterend', empty);
      }
    } else empty?.remove();
    const status = $('[data-aury-search-status]', tools);
    if (status) status.textContent = `${visible} von ${items().length} geladenen Artikeln sichtbar${totalProducts > items().length ? ` · ${totalProducts} insgesamt` : ''}`;
  };

  const currentMoreLink = () => $('.aury-results-more [data-aury-load-more]', root);
  const setLoading = (on, label = '') => {
    loading = on;
    const btn = $('[data-aury-load-all]', tools);
    if (btn) { btn.disabled = on || !currentMoreLink(); btn.innerHTML = on ? `<span class="aurymed-load-state">${esc(label || 'Lade')}</span>` : `↧ <span>${currentMoreLink() ? 'Alle laden' : 'Alle geladen'}</span>`; }
  };

  const appendNextPage = async () => {
    if (loading) return false;
    const link = currentMoreLink();
    if (!link) return false;
    setLoading(true, 'Lade weitere');
    try {
      const response = await fetch(link.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('load');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sourceGrid = doc.querySelector('collection-component .product-grid');
      const newItems = sourceGrid ? [...sourceGrid.children].filter((n) => n.matches?.('.product-grid__item')) : [];
      newItems.forEach((node) => grid.appendChild(document.importNode(node, true)));
      const next = doc.querySelector('.aury-results-more [data-aury-load-more]');
      const currentBox = $('.aury-results-more', root);
      if (next && link) link.href = next.href;
      else if (link) link.remove();
      if (currentBox && !currentBox.querySelector('[data-aury-load-more]')) currentBox.classList.add('is-complete');
      decorateCards(); placeActions(); syncCardStates(); buildChips(); applyFilter();
      return newItems.length > 0;
    } catch (err) {
      const status = $('[data-aury-search-status]', tools);
      if (status) status.textContent = 'Weitere Artikel konnten gerade nicht geladen werden.';
      return false;
    } finally { setLoading(false); }
  };

  const loadAll = async () => {
    let loops = 0;
    while (currentMoreLink() && loops < 30) {
      const ok = await appendNextPage();
      if (!ok) break;
      loops += 1;
    }
    setLoading(false);
    applyFilter();
  };

  const storedList = (kind) => readStore(keys[kind], []);
  const hasStored = (kind, handle) => storedList(kind).some((x) => x.handle === handle);
  const saveMeta = (kind, meta, max = 60) => {
    let list = storedList(kind).filter((x) => x.handle !== meta.handle);
    list.unshift({ handle:meta.handle, title:meta.title, url:meta.url, image:meta.image, price:meta.price });
    list = list.slice(0, max); writeStore(keys[kind], list); updateCounts(); syncCardStates(); return true;
  };
  const removeMeta = (kind, handle) => { writeStore(keys[kind], storedList(kind).filter((x) => x.handle !== handle)); updateCounts(); syncCardStates(); };
  const toggleMeta = (kind, meta, max) => { if (hasStored(kind, meta.handle)) { removeMeta(kind, meta.handle); return false; } saveMeta(kind, meta, max); return true; };

  const updateCounts = () => {
    ['wishlist','compare','bulk'].forEach((kind) => {
      const count = storedList(kind).length;
      $$(`[data-aury-count="${kind}"]`).forEach((el) => { el.textContent = count; });
    });
    const compareCount = storedList('compare').length;
    $$('[data-aury-tool-label="compare"]').forEach((el) => {
      el.textContent = compareCount > 0 ? `${compareCount} vergleichen` : 'Vergleich';
    });
    $$('[data-aury-open="compare"]').forEach((el) => {
      el.classList.toggle('is-ready', compareCount >= 2);
      el.setAttribute('title', compareCount >= 2 ? `${compareCount} Produkte vergleichen` : 'Produkte zum Vergleich öffnen');
      el.setAttribute('aria-label', compareCount >= 2 ? `${compareCount} Produkte vergleichen` : 'Produkte vergleichen');
    });
  };
  const syncCardStates = () => cards().forEach((card) => {
    const h = card.dataset.auryHandle;
    ['wishlist','compare','bulk'].forEach((kind) => {
      const button = $(`[data-aury-action="${kind}"]`, card);
      const active = hasStored(kind, h);
      if (button) {
        button.classList.toggle('is-active', active);
        if (kind === 'compare') {
          button.dataset.tooltip = active ? 'Aus Vergleich entfernen' : 'Zum Vergleich hinzufügen';
          button.setAttribute('aria-label', `${card.dataset.auryTitle || h} ${active ? 'aus dem Vergleich entfernen' : 'zum Vergleich hinzufügen'}`);
        } else if (kind === 'wishlist') {
          button.dataset.tooltip = active ? 'Aus Merkliste entfernen' : 'Zur Merkliste hinzufügen';
        } else if (kind === 'bulk') {
          button.dataset.tooltip = active ? 'Aus Sammelbestellung entfernen' : 'Zur Sammelbestellung hinzufügen';
        }
      }
    });
  });

  const getProduct = async (metaOrHandle) => {
    const meta = typeof metaOrHandle === 'string' ? { handle:metaOrHandle, url:findCard(metaOrHandle)?.dataset.auryUrl || `/products/${metaOrHandle}` } : metaOrHandle;
    if (productCache.has(meta.handle)) return productCache.get(meta.handle);
    const url = new URL(meta.url || `/products/${meta.handle}`, location.origin);
    const fetchUrl = `${url.pathname}.js`;
    const request = fetch(fetchUrl, { headers:{ Accept:'application/json' } }).then((r) => { if (!r.ok) throw new Error('product'); return r.json(); });
    productCache.set(meta.handle, request);
    try { return await request; } catch (e) { productCache.delete(meta.handle); throw e; }
  };

  const ensureDialog = (kind, title) => {
    let dialog = document.querySelector(`dialog[data-aury-dialog="${kind}"]`);
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'aurymed-dialog'; dialog.dataset.auryDialog = kind;
      dialog.innerHTML = `<div class="aurymed-dialog__head"><h2>${esc(title)}</h2><button class="aurymed-dialog__close" type="button" data-aury-dialog-close aria-label="Schließen">×</button></div><div class="aurymed-dialog__body" data-aury-dialog-body></div>`;
      document.body.appendChild(dialog);
    }
    dialog.querySelector('h2').textContent = title;
    return dialog;
  };
  const showDialog = (dialog) => { if (!dialog.open) dialog.showModal(); };
  const setDialogBody = (dialog, html) => { $('[data-aury-dialog-body]', dialog).innerHTML = html; };

  const productImage = (p) => {
    if (typeof p.featured_image === 'string') return p.featured_image;
    if (p.featured_image?.src) return p.featured_image.src;
    return p.images?.[0]?.src || p.images?.[0] || '';
  };
  const variantImage = (v) => typeof v?.featured_image === 'string' ? v.featured_image : (v?.featured_image?.src || '');
  const priceRange = (p) => {
    const variants = p.variants || [];
    if (!variants.length) return money(p.price || 0);
    const prices = variants.map((v) => Number(v.price || 0));
    const min = Math.min(...prices), max = Math.max(...prices);
    return min === max ? money(min) : `ab ${money(min)}`;
  };
  const optionNames = (p) => (p.options || []).map((o) => typeof o === 'string' ? o : o.name);
  const optionValue = (v, i) => v?.[`option${i+1}`] ?? v?.options?.[i] ?? '';

  const openQuickView = async (meta) => {
    const dialog = ensureDialog('quickview', 'Schnellansicht');
    setDialogBody(dialog, '<div class="aurymed-dialog__empty"><span class="aurymed-load-state">Produkt wird geladen</span></div>'); showDialog(dialog);
    try {
      const p = await getProduct(meta);
      const variants = p.variants || [];
      const first = variants.find((v) => v.available) || variants[0];
      const names = optionNames(p);
      const images = (p.images || []).map((i) => typeof i === 'string' ? i : i.src).filter(Boolean).slice(0,8);
      const descDoc = new DOMParser().parseFromString(`<div>${p.description || ''}</div>`, 'text/html');
      const desc = (descDoc.body.textContent || '').trim().replace(/\s+/g,' ');
      const optionsHTML = names.map((name, i) => {
        const vals = [...new Set(variants.map((v) => optionValue(v,i)).filter(Boolean))];
        return `<label>${esc(name)}<select data-qv-option="${i}">${vals.map((v) => `<option${v===optionValue(first,i)?' selected':''}>${esc(v)}</option>`).join('')}</select></label>`;
      }).join('');
      const hero = variantImage(first) || images[0] || productImage(p);
      setDialogBody(dialog, `<div class="aurymed-qv"><div class="aurymed-qv__media"><img class="aurymed-qv__hero" data-qv-hero src="${esc(hero)}" alt="${esc(p.title)}"><div class="aurymed-qv__thumbs">${images.map((src) => `<button type="button" data-qv-thumb="${esc(src)}"><img src="${esc(src)}" alt=""></button>`).join('')}</div></div><div class="aurymed-qv__info"><h3>${esc(p.title)}</h3><div class="aurymed-qv__price" data-qv-price>${money(first?.price || p.price)}</div><div class="aurymed-qv__availability${first?.available?'':' is-sold'}" data-qv-availability>${first?.available?'Verfügbar':'Aktuell nicht verfügbar'}</div>${desc?`<p class="aurymed-qv__desc">${esc(desc)}</p>`:''}<div class="aurymed-qv__options">${optionsHTML}</div><div class="aurymed-qv__buttons"><button type="button" class="aury-primary" data-qv-add data-variant-id="${first?.id || ''}" ${first?.available?'':'disabled'}>In den Warenkorb</button><button type="button" class="aury-secondary" data-qv-wishlist>♡ Merken</button><button type="button" class="aury-secondary" data-qv-compare>⇄ Vergleichen</button><button type="button" class="aury-secondary" data-qv-bulk>＋ Sammelbestellung</button><a class="aury-secondary" href="${esc(meta.url || `/products/${meta.handle}`)}">Produktseite →</a></div><div data-qv-message aria-live="polite"></div></div></div>`);
      dialog.dataset.handle = meta.handle;
      const update = () => {
        const selected = names.map((_,i) => $(`[data-qv-option="${i}"]`, dialog)?.value || '');
        const v = variants.find((variant) => selected.every((val,i) => optionValue(variant,i) === val)) || first;
        $('[data-qv-price]',dialog).textContent = money(v?.price || 0);
        const av = $('[data-qv-availability]',dialog); av.textContent = v?.available ? 'Verfügbar' : 'Aktuell nicht verfügbar'; av.classList.toggle('is-sold',!v?.available);
        const add = $('[data-qv-add]',dialog); add.dataset.variantId = v?.id || ''; add.disabled = !v?.available;
        const img = variantImage(v); if (img) $('[data-qv-hero]',dialog).src = img;
      };
      $$('[data-qv-option]',dialog).forEach((s) => s.addEventListener('change',update));
      $$('[data-qv-thumb]',dialog).forEach((b) => b.addEventListener('click',() => { $('[data-qv-hero]',dialog).src=b.dataset.qvThumb; }));
      $('[data-qv-wishlist]',dialog)?.addEventListener('click',() => toggleMeta('wishlist',meta,80));
      $('[data-qv-compare]',dialog)?.addEventListener('click',() => { if (!hasStored('compare',meta.handle) && storedList('compare').length>=4) return alert('Für den Vergleich sind maximal 4 Artikel gleichzeitig vorgesehen.'); toggleMeta('compare',meta,4); });
      $('[data-qv-bulk]',dialog)?.addEventListener('click',() => toggleMeta('bulk',meta,80));
      $('[data-qv-add]',dialog)?.addEventListener('click',async(e) => {
        const button=e.currentTarget, id=Number(button.dataset.variantId); if(!id)return;
        button.disabled=true; button.textContent='Wird hinzugefügt …';
        const msg=$('[data-qv-message]',dialog);
        try{await addToCart([{id,quantity:1}]);button.textContent='Hinzugefügt ✓';if(msg)msg.innerHTML='<a href="/cart" style="color:#e5c66e">Warenkorb öffnen →</a>';}
        catch(_){button.textContent='Noch einmal versuchen';button.disabled=false;if(msg)msg.textContent='Das Hinzufügen hat gerade nicht geklappt.';}
      });
    } catch (_) { setDialogBody(dialog,'<div class="aurymed-dialog__empty">Die Schnellansicht konnte gerade nicht geladen werden. Über die Produktseite kannst du den Artikel trotzdem öffnen.</div>'); }
  };

  const openWishlist = () => {
    const list = storedList('wishlist'); const dialog = ensureDialog('wishlist','Deine Merkliste');
    if (!list.length) setDialogBody(dialog,'<div class="aurymed-dialog__empty">Noch nichts gemerkt. Mit ♡ kannst du Artikel hier sammeln.</div>');
    else setDialogBody(dialog,`<div class="aurymed-saved-grid">${list.map((m)=>`<article class="aurymed-saved-card" data-handle="${esc(m.handle)}"><img src="${esc(m.image)}" alt=""><div><h3>${esc(m.title)}</h3><div class="aurymed-saved-card__price">${money(m.price)}</div><div class="aurymed-saved-card__actions"><button type="button" data-aury-saved-action="quickview">Schnellansicht</button><button type="button" data-aury-saved-action="bulk">＋ Sammeln</button><a href="${esc(m.url)}">Öffnen</a><button type="button" data-aury-saved-action="remove-wishlist">Entfernen</button></div></div></article>`).join('')}</div>`);
    showDialog(dialog);
  };

  const openCompare = async () => {
    const list = storedList('compare'); const dialog=ensureDialog('compare','Produkte vergleichen');
    if (!list.length){setDialogBody(dialog,'<div class="aurymed-dialog__empty">Noch keine Vergleichsartikel ausgewählt. Nutze ⇄ an einem Produkt.</div>');showDialog(dialog);return;}
    setDialogBody(dialog,'<div class="aurymed-dialog__empty"><span class="aurymed-load-state">Vergleich wird aufgebaut</span></div>');showDialog(dialog);
    const products=(await Promise.allSettled(list.map(getProduct))).filter(x=>x.status==='fulfilled').map(x=>x.value);
    const count=products.length||1;
    const row=(label,fn)=>`<div class="aurymed-compare__label">${esc(label)}</div>${products.map((p)=>`<div class="aurymed-compare__value">${fn(p)}</div>`).join('')}`;
    const productRow=`<div class="aurymed-compare__label">Artikel</div>${products.map((p)=>`<div class="aurymed-compare__product"><button class="aurymed-compare__remove" type="button" data-compare-remove="${esc(p.handle)}">×</button><img src="${esc(productImage(p))}" alt=""><strong>${esc(p.title)}</strong></div>`).join('')}`;
    const html=`<div class="aurymed-compare-wrap"><div class="aurymed-compare" style="--aury-compare-count:${count}">${productRow}${row('Preis',(p)=>esc(priceRange(p)))}${row('Größe',(p)=>esc(extractSize(p.title)?.label||'–'))}${row('Verfügbarkeit',(p)=>p.available?'verfügbar':'nicht verfügbar')}${row('Varianten',(p)=>String(p.variants?.length||1))}${row('Auswahl',(p)=>esc(optionNames(p).join(' · ')||'–'))}${row('Produktseite',(p)=>`<a class="aury-secondary" href="/products/${esc(p.handle)}">Öffnen →</a>`)}</div></div>`;
    setDialogBody(dialog,html);
  };

  const openBulk = async () => {
    const list=storedList('bulk'); const dialog=ensureDialog('bulk','Mix- & Großbestellung');
    if(!list.length){setDialogBody(dialog,'<div class="aurymed-dialog__empty">Noch keine Artikel ausgewählt. Mit ＋ kannst du verschiedene Produkte sammeln und anschließend gemeinsam in den Warenkorb legen.</div>');showDialog(dialog);return;}
    setDialogBody(dialog,'<div class="aurymed-dialog__empty"><span class="aurymed-load-state">Auswahl wird geladen</span></div>');showDialog(dialog);
    const results=await Promise.allSettled(list.map(async(m)=>({meta:m,p:await getProduct(m)})));
    const data=results.filter(r=>r.status==='fulfilled').map(r=>r.value);
    const rows=data.map(({meta,p})=>{
      const variants=(p.variants||[]).filter(v=>v.available); const first=variants[0]||p.variants?.[0];
      return `<div class="aurymed-bulk-row" data-bulk-handle="${esc(meta.handle)}"><img src="${esc(productImage(p)||meta.image)}" alt=""><div class="aurymed-bulk-row__title">${esc(p.title)}</div><select data-bulk-variant>${variants.map(v=>`<option value="${v.id}" data-price="${v.price}">${esc(v.title==='Default Title'?'Standard':v.title)} · ${money(v.price)}</option>`).join('')}</select><input data-bulk-qty type="number" min="1" step="1" value="1" aria-label="Anzahl"><span class="aurymed-bulk-row__price" data-bulk-price>${money(first?.price||0)}</span><button type="button" data-bulk-remove="${esc(meta.handle)}" aria-label="Entfernen">×</button></div>`;
    }).join('');
    setDialogBody(dialog,`<div class="aurymed-bulk-list">${rows}</div><div class="aurymed-bulk-footer"><div class="aurymed-bulk-summary" data-bulk-summary>Varianten auswählen und Anzahl festlegen.</div><button type="button" class="aury-primary" data-bulk-add>Alles in den Warenkorb</button></div>`);
    $$('[data-bulk-variant]',dialog).forEach(sel=>sel.addEventListener('change',()=>{const row=sel.closest('.aurymed-bulk-row');const opt=sel.selectedOptions[0];$('[data-bulk-price]',row).textContent=money(opt?.dataset.price||0);}));
    $('[data-bulk-add]',dialog)?.addEventListener('click',async(e)=>{
      const cartItems=$$('.aurymed-bulk-row',dialog).map(row=>({id:Number($('[data-bulk-variant]',row)?.value),quantity:Math.max(1,Number($('[data-bulk-qty]',row)?.value||1))})).filter(i=>i.id);
      if(!cartItems.length)return;
      e.currentTarget.disabled=true;e.currentTarget.textContent='Wird hinzugefügt …';
      try{await addToCart(cartItems);e.currentTarget.textContent='Alles hinzugefügt ✓';$('[data-bulk-summary]',dialog).innerHTML=`${cartItems.length} Positionen hinzugefügt · <a href="/cart" style="color:#e5c66e">Warenkorb öffnen →</a>`;}
      catch(_){e.currentTarget.disabled=false;e.currentTarget.textContent='Noch einmal versuchen';$('[data-bulk-summary]',dialog).textContent='Das Hinzufügen hat gerade nicht vollständig geklappt.';}
    });
  };

  const addToCart = async (cartItems) => {
    const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:cartItems})});
    if(!r.ok)throw new Error('cart');
    try{const cart=await fetch('/cart.js').then(x=>x.json());$$('[data-v61-cart] span').forEach(el=>el.textContent=`Warenkorb${cart.item_count?` (${cart.item_count})`:''}`);}catch(_){}
    document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true}));
    return r.json();
  };

  // Hover image swap in tile modes; list/table keep the v69 floating preview.
  const hoverState=new WeakMap();
  document.addEventListener('pointerover',(event)=>{
    const gallery=event.target.closest?.('collection-component .card-gallery'); if(!gallery)return;
    const card=gallery.closest('product-card'); const view=grid.getAttribute('product-grid-view');
    if(!card?.dataset.aurySecondImage || !['default','large','zoom-out'].includes(view))return;
    if(hoverState.has(gallery))return;
    const img=$('img',gallery); if(!img)return;
    hoverState.set(gallery,{src:img.getAttribute('src'),srcset:img.getAttribute('srcset')});
    img.removeAttribute('srcset');img.src=card.dataset.aurySecondImage;
  });
  document.addEventListener('pointerout',(event)=>{
    const gallery=event.target.closest?.('collection-component .card-gallery'); if(!gallery||!hoverState.has(gallery))return;
    if(event.relatedTarget?.closest?.('.card-gallery')===gallery)return;
    const img=$('img',gallery),state=hoverState.get(gallery); if(img&&state){if(state.src)img.src=state.src;if(state.srcset)img.setAttribute('srcset',state.srcset);else img.removeAttribute('srcset');}hoverState.delete(gallery);
  });

  // Event delegation.
  document.addEventListener('click',(event)=>{
    const close=event.target.closest?.('[data-aury-dialog-close]'); if(close){close.closest('dialog')?.close();return;}
    const action=event.target.closest?.('[data-aury-action]');
    if(action){event.preventDefault();event.stopPropagation();const card=action.closest('product-card');if(!card)return;const meta=cardMeta(card);const kind=action.dataset.auryAction;
      if(kind==='quickview')openQuickView(meta);
      if(kind==='wishlist')toggleMeta('wishlist',meta,80);
      if(kind==='compare'){if(!hasStored('compare',meta.handle)&&storedList('compare').length>=4)return alert('Für den Vergleich sind maximal 4 Artikel gleichzeitig vorgesehen.');toggleMeta('compare',meta,4);}
      if(kind==='bulk')toggleMeta('bulk',meta,80);
      return;
    }
    const open=event.target.closest?.('[data-aury-open]'); if(open){const kind=open.dataset.auryOpen;if(kind==='wishlist')openWishlist();if(kind==='compare')openCompare();if(kind==='bulk')openBulk();return;}
    const chip=event.target.closest?.('[data-aury-chip]'); if(chip){const key=chip.dataset.auryChip;if(key==='__clear')activeFilters.clear();else activeFilters.has(key)?activeFilters.delete(key):activeFilters.add(key);buildChips();applyFilter();return;}
    const more=event.target.closest?.('[data-aury-load-more]'); if(more){event.preventDefault();appendNextPage();return;}
    const all=event.target.closest?.('[data-aury-load-all]'); if(all){event.preventDefault();loadAll();return;}
    const saved=event.target.closest?.('[data-aury-saved-action]'); if(saved){const card=saved.closest('[data-handle]');const handle=card?.dataset.handle;const meta=storedList('wishlist').find(x=>x.handle===handle)||storedList('bulk').find(x=>x.handle===handle)||{handle,url:`/products/${handle}`};if(saved.dataset.aurySavedAction==='quickview')openQuickView(meta);if(saved.dataset.aurySavedAction==='bulk')saveMeta('bulk',meta,80);if(saved.dataset.aurySavedAction==='remove-wishlist'){removeMeta('wishlist',handle);card.remove();}return;}
    const cr=event.target.closest?.('[data-compare-remove]');if(cr){removeMeta('compare',cr.dataset.compareRemove);openCompare();return;}
    const br=event.target.closest?.('[data-bulk-remove]');if(br){removeMeta('bulk',br.dataset.bulkRemove);br.closest('.aurymed-bulk-row')?.remove();return;}
  },true);

  $('[data-aury-collection-search]',tools)?.addEventListener('input',applyFilter);
  $('[data-aury-search-clear]',tools)?.addEventListener('click',()=>{const input=$('[data-aury-collection-search]',tools);if(input){input.value='';input.focus();}applyFilter();});

  // Column chooser.
  const colDefaults={size:true,unit:true,price:true,actions:true};
  const colState={...colDefaults,...readStore(keys.columns,{})};
  const applyColumns=()=>{Object.entries(colState).forEach(([k,v])=>root.classList.toggle(`aury-hide-${k}`,!v));$$('[data-aury-column]',tools).forEach(inp=>inp.checked=colState[inp.value]!==false);};
  $$('[data-aury-column]',tools).forEach(inp=>inp.addEventListener('change',()=>{colState[inp.value]=inp.checked;writeStore(keys.columns,colState);applyColumns();}));

  // Remember exact browsing position before opening a product and restore on return.
  document.addEventListener('click',(event)=>{const link=event.target.closest?.('collection-component product-card a[href*="/products/"]');if(!link)return;try{sessionStorage.setItem(keys.browse,JSON.stringify({url:location.pathname+location.search,y:scrollY,at:Date.now()}));}catch(_){}},true);
  try{const state=JSON.parse(sessionStorage.getItem(keys.browse)||'null');if(state&&state.url===location.pathname+location.search&&Date.now()-state.at<30*60*1000&&document.referrer.includes('/products/'))requestAnimationFrame(()=>setTimeout(()=>scrollTo({top:state.y,behavior:'instant'}),80));}catch(_){}

  // Keep new cards decorated after Shopify facet morphs and reposition actions whenever the view changes.
  const observer=new MutationObserver((mutations)=>{
    const added = mutations.some(m=>m.type==='childList' && m.addedNodes.length);
    const viewChanged = mutations.some(m=>m.type==='attributes' && m.attributeName==='product-grid-view');
    if (added) { decorateCards(); syncCardStates(); buildChips(); applyFilter(); }
    if (added || viewChanged) requestAnimationFrame(placeActions);
  });
  observer.observe(grid,{childList:true,subtree:false,attributes:true,attributeFilter:['product-grid-view']});

  decorateCards(); placeActions(); updateCounts(); syncCardStates(); buildChips(); applyFilter(); applyColumns(); setLoading(false);
})();
